export function setValue([field, value], state, { changeValue }) {
  changeValue(state, field, () => value);
}
